export default {
  computed: {
    classes () {
      return {
        'dn-tabs__bar': true,
      }
    },
  },



  render(h) {
    const container = h('div', {
      'class': 'dn-tabs__container',
      ref    : 'container'
    }, this.$slots.default);

    return h('div', {
      'class': this.classes,
    }, [container]);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/tabs/TabsBar.js